import { ISectionImageFreeFlowProps } from "../SectionImageFreeFlow";

export const sectionImageFreeFlowData: Omit<ISectionImageFreeFlowProps, "children"> = {
  image: {
    image: {
      src: "/images/dev/components/LandingPage/founders.webp",
      width: 709,
      height: 550,
    },
    alt: "Nikki and Bret - Founders of KatKin",
  },
};
